import { connect } from "react-redux";
import PropTypes from "prop-types";

import PremierPageFrameContainer from "../../containers/PremierPageFrameContainer/index.jsx";
import PremierErrorContainer from "../../containers/PremierErrorContainer/index.jsx";
import PremierHeroContainer from "../../containers/PremierHeroContainer/index.jsx";
import PremierReturnRateBanner from "../../components/PremierReturnRateBanner/index.jsx";
import PremierUnavailableMessageContainer from "../../containers/PremierUnavailableMessageContainer/index.jsx";
import PremierSubscriptionPlansContainer from "../../containers/PremierSubscriptionPlansContainer/index.jsx";
import PremierBenefits from "../../components/PremierBenefits/index.jsx";
import PremierHowItWorks from "../../components/PremierHowItWorks/index.jsx";
import PremierDeliveryFAQsContainer from "../../containers/PremierDeliveryFAQsContainer/index.jsx";
import { useHighReturner } from "../../hooks/useHighReturner";

// Temporarily hidden while market-specific content is reviewed; enable to reinstate.
const SHOW_HOW_IT_WORKS = false;
const SHOW_BENEFITS = false;

const PremierLandingPageLayout = ({ appConfig, premierAvailable }) => {
  const { highReturner, checking } = useHighReturner(appConfig);

  return (
    <div className="PremierLandingPageWrapper">
      <PremierErrorContainer />
      <PremierPageFrameContainer>
        <div className="PremierContentContainer">
          {premierAvailable ? (
            <>
              <PremierReturnRateBanner highReturner={highReturner} />
              <PremierHeroContainer highReturner={highReturner} />
              <PremierSubscriptionPlansContainer
                highReturner={highReturner}
                checkingEligibility={checking}
              />
              {SHOW_BENEFITS && <PremierBenefits />}
              {SHOW_HOW_IT_WORKS && <PremierHowItWorks />}
              <PremierDeliveryFAQsContainer />
            </>
          ) : (
            <PremierUnavailableMessageContainer />
          )}
        </div>
      </PremierPageFrameContainer>
    </div>
  );
};

PremierLandingPageLayout.propTypes = {
  appConfig: PropTypes.object,
  premierAvailable: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  premierAvailable: state.CountrySelector.premierAvailable,
});

export default connect(mapStateToProps)(PremierLandingPageLayout);
